import { whatsappLink, WHATSAPP_MESSAGES } from "@/config/site";
import { trackEvent } from "@/lib/analytics";
import { WhatsAppIcon } from "@/components/site/WhatsAppIcon";

export const WhatsAppButton = ({ message = WHATSAPP_MESSAGES.general, product, label = "WhatsApp Us", className = "btn btn-whatsapp", testid = "whatsapp-button", location = "inline" }) => (
  <a
    href={whatsappLink(message)}
    target="_blank"
    rel="noopener noreferrer"
    className={className}
    data-testid={testid}
    onClick={() => trackEvent("whatsapp_click", { product: product || "general", location })}
  >
    <WhatsAppIcon className="h-[18px] w-[18px]" />
    <span>{label}</span>
    <span className="sr-only"> (opens WhatsApp in a new tab)</span>
  </a>
);
